import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#075FCE",
      d: "M7.155 1.266a6.432 6.432 0 1 1 0 12.864 6.432 6.432 0 0 1 0-12.864"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m9.012 5.432.424.424a.343.343 0 0 1 0 .485L8.072 7.706 9.436 9.07a.343.343 0 0 1 0 .485l-.424.424a.343.343 0 0 1-.485 0L7.162 8.615 5.798 9.98a.343.343 0 0 1-.485 0l-.424-.425a.343.343 0 0 1 0-.485l1.363-1.364L4.89 6.342a.343.343 0 0 1 0-.485l.424-.425a.343.343 0 0 1 .485 0l1.364 1.364 1.365-1.364a.343.343 0 0 1 .485 0"
    }, null, -1)
  ]))]))
}
export default { render: render }